document.addEventListener('DOMContentLoaded', () => {
    const items = document.querySelectorAll('.item-desktop-timeline');
    const container = items[0].parentElement;

    items.forEach((item) => {
        const gifDesktop = item.querySelector('.timeline-gif-desktop');
        if (gifDesktop.src.includes('no-image')) {
            return;
        }
        const gifUrl = gifDesktop.src;
        const image = new Image();
        image.src = gifUrl;
        gifDesktop.style.display = 'none';
    });

    const firstItem = items[0];
    firstItem.classList.add('active');
    const firstItemImage = firstItem.querySelector('.timeline-img-desktop');
    const firstItemGif = firstItem.querySelector('.timeline-gif-desktop');
    if (firstItemGif.src) {
        firstItemImage.style.display = 'none';
        firstItemGif.style.display = 'block';
    }

    for (let i = 1; i < items.length; i++) {
        const currentItem = items[i];
        currentItem.classList.remove('active');
        const currentItemImg = currentItem.querySelector('.timeline-img-desktop');
        const currentItemGif = currentItem.querySelector('.timeline-gif-desktop');
        currentItemImg.style.display = 'block';
        currentItemGif.style.display = 'none';
    }

    const totalItems = items.length;
    items.forEach((item) => {
        item.addEventListener('click', (event) => {
            event.preventDefault();

            items.forEach((otherItem) => {
                otherItem.classList.remove('active');
                otherItem.style.width = `${100 / totalItems}%`;
                otherItem.querySelector('.timeline-desktop-content').style.display = 'none';
                toggleImage(otherItem, false);
            });

            item.classList.add('active');
            item.querySelector('.timeline-desktop-content').style.display = 'block';
            toggleImage(item, true);

            const activeItemWidth = container.clientWidth * 0.246363;
            item.style.width = `${activeItemWidth}px`;

            const inactiveItemsCount = items.length - 1;
            const inactiveItemsWidth = (container.clientWidth - activeItemWidth) / inactiveItemsCount;

            items.forEach(function (otherItem) {
                if (!otherItem.classList.contains('active')) {
                    otherItem.style.width = `${inactiveItemsWidth}px`;
                }
            });
        });

        function toggleImage(item, isActive) {
            const imageDesktop = item.querySelector('.timeline-img-desktop');
            const gifDesktop = item.querySelector('.timeline-gif-desktop');
            if (isActive && gifDesktop.src) {
                if (!gifDesktop.src.includes('no-image')) {
                    imageDesktop.style.display = 'none';
                    gifDesktop.style.display = 'block';
                } else {
                    imageDesktop.style.display = 'block';
                    gifDesktop.style.display = 'none';
                }
            } else {
                imageDesktop.style.display = 'block';
                gifDesktop.style.display = 'none';
            }
        }
    });
});

function toggleImage(currentSlide) {
    $('.timeline-mobile .item-mobile').each(function (index) {
        const imageContainer = $(this).find('.timeline-image-container');
        const image = imageContainer.find('.timeline-img-mobile');
        const gif = imageContainer.find('.timeline-gif-mobile');
        if (index === currentSlide) {
            if (gif.attr('src').indexOf('no-image') === -1) {
                image.css('display', 'none');
                gif.css('display', 'block');
            } else {
                image.css('display', 'block');
                gif.css('display', 'none');
            }
        } else {
            image.css('display', 'block');
            gif.css('display', 'none');
        }
    });
}